<script>

import { ExclamationCircleIcon } from "@heroicons/vue/outline";

export default {
    components: { ExclamationCircleIcon },
    props: [
        "state",
        "rejectionReason"
    ]
};
</script>

<template>
    <div
        v-if="state === 'declined'"
        class="mt-4 flex items-start space-x-3 p-3 bg-red-100"
    >
        <ExclamationCircleIcon class="h-6 w-6 text-red-600" />
        <p class="text-red-800 font-semibold text-md">
            {{ $t("orderModifications.declinedMessage") }} <br />
            <span class="font-normal break-text"
            >{{ $t("orderModifications.declinedReason") }}
                            {{ rejectionReason }}</span
            >
        </p>
    </div>
</template>

<style scoped>
.break-text {
    word-break: break-word;
    overflow-wrap: anywhere;
}
</style>
